import React, {useState } from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';

// List Options
const options = [
    "Arial", "Times New Roman", "Consolas", "Comic Sans MS", "Impact"
];

// Imported from MUI: https://mui.com/material-ui/react-menu/
const FontFamilyMenu = ({editor}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedIndex, setSelectedIndex] = useState(0);
    const open = Boolean(anchorEl);

    const handleClickListItem = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuItemClick = (event, index) => {
        setSelectedIndex(index);
        console.log(index)
        console.log(options[index])
        editor.chain().focus().setFontFamily(options[index]).run()
        setAnchorEl(null);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <div>
            <List
                component="nav"
                sx={{ bgcolor: 'background.paper' }}
            >
                <ListItem
                    button
                    aria-expanded={open ? 'true' : undefined}
                    onClick={handleClickListItem}
                    sx = {{height: 10, width: 170}}
                >
                <ListItemText
                    primary={options[selectedIndex]}
                    sx = {{fontSize: 1, fontFamily: options[selectedIndex]}}
                />
                </ListItem>
            </List>
        <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
        >
            {options.map((option, index) => (
            <MenuItem
                key={option}
                selected={index === selectedIndex}
                onClick={(event) => handleMenuItemClick(event, index)}
            >
                {option}
            </MenuItem>
            ))}
        </Menu>
        </div>
  );
}

export default FontFamilyMenu;